'use client';

import React, { useState, useEffect } from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { Modal } from '@depop/web-ui-kit/Modal';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function SFYSignUpSuccessModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [isAuthenticated] = useCurrentUser();
  const t = useTranslations('common');
  const searchParams = useSearchParams();
  const cloudfrontHost = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

  const showSfyModal = searchParams.get('showSfyModal');

  useEffect(() => {
    if (showSfyModal === '1' && isAuthenticated) {
      setIsOpen(true);
      const url = new URL(window.location.href);
      url.searchParams.delete('showSfyModal');
      window.history.replaceState({}, '', url.toString());
    }
  }, [showSfyModal]);

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setIsOpen}
      customOverrides={{
        header: (
          <div className={styles.header}>
            <img
              src={`${cloudfrontHost}/web/assets/images/depop-smile-sticker.png`}
              alt=""
              className={styles.logo}
            />
            <Heading variant="md">{t('SFYSignUpSuccessModal.Title')}</Heading>
            <Body variant="sm-regular" className={styles.description}>
              {t('SFYSignUpSuccessModal.Description')}
            </Body>
            <div className={styles.buttonContainer}>
              <ButtonExperiment
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                {t('SFYSignUpSuccessModal.CloseButton')}
              </ButtonExperiment>
            </div>
          </div>
        ),
      }}
      content={() => null}
    />
  );
}
